import { createApp, ref } from 'vue'
import App from './App.vue'
import Vue3MobileDetection from "vue3-mobile-detection";
import { i18n } from './i18n';
import './assets/styles.css';
import router from './router/index.js'

const app = createApp(App)
app.use(Vue3MobileDetection);
app.use(i18n);
app.use(router);

const isMobile = ref(false)

const checkMobile = () => {
    isMobile.value = window.innerWidth < 750
}

checkMobile();
window.addEventListener('resize', checkMobile);

app.provide('isMobile', isMobile)


app.mount('#app')

